var idleJs = require('idle-js');

module.exports = (function() {
  var interval = null;
  var params = {};
  var ping = {
    start() {
      axios.get('/api/ping', { params });
      interval = setInterval(function() {
        axios.get('/api/ping', { params });
      }, 1000 * 60);
    },
    stop() {
      clearInterval(interval);
    },
    pingAsContact(contact_id) {
      params.contact_id = contact_id;
    }
  };
  var idle = new idleJs({
    idle: 5000,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
    onIdle: ping.stop,
    onActive: ping.start,
    onHide: ping.stop,
    onShow: ping.start,
    keepTracking: true,
    startAtIdle: false
  }).start();

  return ping;
})();



// WEBPACK FOOTER //
// ./resources/assets/js/ping.js